import styled from 'styled-components';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { maxWidth, minHeight, space } from 'styled-system';

interface Props extends StyledSystemProps {
  size: string;
  direction: string;
  zIndex?: string;
  justify?: string;
  height?: string;
  width?: string;
  padding?: string;
  marginRight?: string;
  marginBottom?: string;
  marginTop?: string;
  margin?: string;
  maxHeight?: string;
  align?: string;
}

const Flex = styled.div<Props>`
  align-items: ${({ alignItems }) => alignItems};
  display: flex;
  flex: ${props => props.size};
  flex-direction: ${props => props.direction};
  flex-wrap: ${props => props.flexWrap};
  height: ${props => props.height};
  width: ${props => props.width};
  justify-content: ${props => props.justify};
  margin-right: ${props => props.marginRight};
  z-index: ${props => props.zIndex};
  margin-bottom: ${props => props.marginBottom};
  padding: ${props => props.padding};
  margin-top: ${props => props.marginTop};
  margin: ${props => props.margin};
  ${props => (props.maxHeight ? `max-height: ${props.maxHeight};` : '')}

  ${maxWidth};
  ${minHeight};
  ${space};
`;

Flex.defaultProps = {
  flexWrap: 'wrap',
  size: '1',
};

export default Flex;
